import { AdminState } from '../types/admin-state';
import * as Actions from '../actions/admin.actions';
import * as Constants from '../actions/admin.constants';

const defaultState: AdminState = {
  organisations: {
    isRequesting: false,
    hasRequested: false,
    data: []
  }
};

export function reducer(
  state: AdminState = defaultState,
  action: Actions.All
): AdminState {
  switch (action.type) {
    case Constants.LOAD_ORGANISATIONS: {
      return { ...state, organisations: { ...state.organisations, isRequesting: true } };
    }
    case Constants.LOAD_ORGANISATIONS_DONE: {
      const { organisations } = action as Actions.LoadOrganisationsDoneAction;
      return {
        ...state, organisations: {
          isRequesting: false,
          hasRequested: true,
          data: organisations
        }
      };
    }
    case Constants.ORGANISATION_STATE_UPDATE_REQUEST: {
      const { payload: { orgId, deactivate } } = action as Actions.UpdateOrganisationStateRequestAction;
      const organisation = state.organisations.data.find(org => org.id === orgId);
      if (organisation) {
        organisation.deactivatedAt = deactivate ? 'Just now' : null;
      }
      return {
        ...state,
        organisations: {
          ...state.organisations,
          data: [
            ...state.organisations.data
          ]
        }
      };
    }
    case Constants.ORGANISATION_STATE_UPDATE_FAILED: {
      const { payload: { orgId, deactivate } } = action as Actions.UpdateOrganisationStateFailedAction;
      const organisation = state.organisations.data.find(org => org.id === orgId);
      if (organisation) {
        organisation.deactivatedAt = !deactivate ? 'Update failed' : null;
      }
      return {
        ...state,
        organisations: {
          ...state.organisations,
          data: [
            ...state.organisations.data
          ]
        }
      };
    }
    case Constants.MEMBER_STATE_UPDATE_REQUEST: {
      const { payload: { orgId, memberId, active } } = action as Actions.UpdateMemberStateRequestAction;
      const organisation = state.organisations.data.find(org => org.id === orgId);
      if (organisation && organisation.members) {
        const member = organisation.members.find(m => m.id === memberId);
        if (member) {
          member.is_active = active;
        }
      }
      return {
        ...state,
        organisations: {
          ...state.organisations,
          data: [
            ...state.organisations.data
          ]
        }
      };
    }
    case Constants.MEMBER_STATE_UPDATE_FAILED: {
      const { payload: { orgId, memberId, active } } = action as Actions.UpdateMemberStateFailedAction;
      const organisation = state.organisations.data.find(org => org.id === orgId);
      if (organisation && organisation.members) {
        const member = organisation.members.find(m => m.id === memberId);
        if (member) {
          member.is_active = !active;
        }
      }
      return {
        ...state,
        organisations: {
          ...state.organisations,
          data: [
            ...state.organisations.data
          ]
        }
      };
    }
    default: {
      return state;
    }
  }
}